module.exports = __webpack_public_path__ + "static/assignment_5-ff93435bae4e25669b3a6370dad5ffa9.gif";